import { render, staticRenderFns } from "./StartupPartnershipsModal.vue?vue&type=template&id=dfd7969a&scoped=true&"
import script from "./StartupPartnershipsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupPartnershipsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd7969a",
  null
  
)

export default component.exports